import { render, staticRenderFns } from "./TableSchool.vue?vue&type=template&id=7c0c6b76&scoped=true"
import script from "./TableSchool.vue?vue&type=script&lang=js"
export * from "./TableSchool.vue?vue&type=script&lang=js"
import style0 from "./TableSchool.vue?vue&type=style&index=0&id=7c0c6b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0c6b76",
  null
  
)

export default component.exports